import React, {Fragment} from "react"
import { withStyles } from '@material-ui/core/styles'
import NavBar from "../../NavBar"
import Grid from '@material-ui/core/Grid'
import { connect } from "react-redux"
import moment from 'moment'

import {setDate, setFirstDate, previousMonth, nextMonth} from '../../../actions/calendarActions'

import {
  setFromDate,
  setToDate
} from '../../../actions/newAppointmentActions'

import AppointmentList from '../appointment/AppointmentList'
import Calendar from './calendar/Calendar'

const styles = theme => ({
  primaryColor: {
    color: '#009fe3',
  },
  weekGrid: {
    width: '14.2%',
    backgroundColor: '#3c3c3c',
    height:40,
    color:'#949494'
  },
  weekGridOdd: {
    width: '14.2%',
    backgroundColor: '#666666',
    height:40,
    color:'#949494'
  },
  weekDay: {
    fontSize:14,
    marginTop: 10
  },
  weekDigit: {
    fontSize:45,
    fontWeight:'bold'
  },
  button: {
    position: 'fixed',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
  },
})

class Month extends React.Component {

  constructor(props){
    super(props)

    props.dispatch(setFirstDate(moment(this.props.match.params.month, 'YYYYMMDD')))
  }

  onClickDay = (d) => {
    this.props.dispatch(setDate(d, this.props.calendar.date))
    this.props.dispatch(setFromDate(d))
    this.props.dispatch(setToDate(d))


  }

  onClickSetToday = () => {
    this.props.dispatch(setDate(moment(), this.props.calendar.date))
  }

  nextMonth = (e, originalX, endX) => {
    if(endX < originalX - 100) this.props.dispatch(nextMonth(this.props.calendar.date))
  }

  previousMonth = (e, originalX, endX) => {
    if(endX > originalX + 100) this.props.dispatch(previousMonth(this.props.calendar.date))
  }

  render() {
    return (
      <div>
        <NavBar/>
        {this.props.calendar.date === null ? (
          null
        ) : (
          <Fragment>
            <Grid container justify="center">
              <Grid item container xs={12} md={6}>
                <Calendar
                  calendar={this.props.calendar}
                  onClickDay={this.onClickDay}
                  nextMonth={this.nextMonth}
                  previousMonth={this.previousMonth}
                  onClickSetToday={this.onClickSetToday} />
              </Grid>
            </Grid>
            <Grid container justify="center">
              <Grid item xs={12} md={6}>
                <AppointmentList date={this.props.calendar.date} />
              </Grid>
            </Grid>
          </Fragment>
        )}
      </div>
    )
  }
}


const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  calendar: state.calendar
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Month))



// WEBPACK FOOTER //
// ./src/js/components/pages/month/Month.js